import { useLocation, useNavigate } from "react-router-dom";
import { checkAndRedirect, selectAuthStatus, selectUser, UserState } from "../newapi/user/authentication/authSlice";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useTheme } from "@mui/material";
import { motion } from 'framer-motion';
import { tokens } from "../theme";

// Stores bol.com / TikTok Shop OAuth params from the current URL into localStorage
// so Login.jsx can redirect to the correct saleschannels page after the user logs in.
const captureOAuthParams = (location) => {
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');

    if (type === 'bol') {
        const state = searchParams.get('state');
        const code = searchParams.get('code');
        const expires = new Date(Date.now() + 60 * 60 * 1000).toUTCString();

        if (state) localStorage.setItem("bol_oauth_state", state);
        if (code) localStorage.setItem("bol_oauth_code", code);
        localStorage.setItem("bol_oauth_expires", expires);
        return;
    }

    if (type === 'tiktokshop') {
        const code = searchParams.get('code');
        const region = searchParams.get('shop_region');
        // TikTok auth codes live <= 30 minutes; stash for 25 to stay safely inside that window.
        const expires = new Date(Date.now() + 25 * 60 * 1000).toUTCString();

        if (code) localStorage.setItem("tiktok_oauth_code", code);
        if (region) localStorage.setItem("tiktok_oauth_region", region);
        localStorage.setItem("tiktok_oauth_expires", expires);
        return;
    }
};

export const RequireAuth = React.memo((props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const location = useLocation();
    const user = useSelector(selectUser);

    // useEffect(() => {
    //   console.log("RequireAuth mounted or updated for:", location.pathname);
    // }, [location.pathname]);

    useEffect(() => {
        // Always check login status first regardless of route type
        if(auth.status === UserState.LOGGED_OUT) {
            captureOAuthParams(location);
            navigate('/login');
            return;
        }
        if(props.superUser) {
            if(!user?.sha) {
                navigate("/login");
            }
            return;
        }
        if(props.permissions){
            dispatch(checkAndRedirect(props.permissions))
          .unwrap() // <-- async Thunk returns a promise, that can be 'unwrapped')
          .then(({loggedOut, authorized}) => {
            if(loggedOut) {
                captureOAuthParams(location);
                navigate("/login");
            } else if (authorized !== null && !authorized) {
                navigate(props.path ?? "/login");
            }
          });
        }
        // dispatch(checkAndRedirect()).unwrap()
    }, [dispatch, navigate,auth]);

    // useEffect(() => {
    //     console.log("RequireAuth re-rendered");
    //   }, []);
    // return (
    //     <motion.div
    //         // key={props.path}
    //         key={location.pathname} // force remount on route change
    //         // component="main" // optional, may not be needed depending on your layout
            
    //         initial={{ opacity: 0, y: -10 }}
    //         animate={{ opacity: 1, y: 0 }}
    //         exit={{ opacity: 0, y: -20 }}
    //         transition={{ duration: 0.4, ease: "easeOut" }}
    //         style={{
    //             background:
    //             theme.palette.mode === "dark"
    //                 ? colors.bg['tertiary']
    //                 : colors.grey["0"],
    //             width: "100%",      // mimic Box default behavior
    //             // height: "100%",     // optional, adjust based on layout
    //         }}
    //     >
    //         {props.children}
    //     </motion.div>
    // )
    return props.children;
});